var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 15c-1.723 0-3.392.23-4.979.659C19.943 17.847 14 25.229 14 34",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.819 57.628.203.18 8.797 7.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.723 65.349a4.847 4.847 0 0 0 .239 6.85L77.427 82.89a4.847 4.847 0 1 0 6.611-7.089L72.573 65.11a4.847 4.847 0 0 0-6.85.239Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.71417eaa9fac4ee876aa2065c8fe1c47.svg";
export { ForwardRef as ReactComponent };